import { supabase } from './supabase-client';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;

export async function callEdgeFunction(functionName: string, body: any) {
  const { data: { session } } = await supabase.auth.getSession();

  const url = `${SUPABASE_URL}/functions/v1/${functionName}`;

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  if (session?.access_token) {
    headers['Authorization'] = `Bearer ${session.access_token}`;
  }

  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Unknown error' }));
    const errorMessage = error.message || error.error || error.details || 'Edge function call failed';
    throw new Error(errorMessage);
  }

  return response.json();
}

export async function uploadFile(file: File, bucket: string = 'resumes', userId?: string) {
  const { data: { session } } = await supabase.auth.getSession();

  const formData = new FormData();
  formData.append('file', file);
  formData.append('bucket', bucket);
  if (userId) {
    formData.append('userId', userId);
  }

  const url = `${SUPABASE_URL}/functions/v1/upload-file`;

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${session?.access_token || ''}`,
    },
    body: formData,
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Upload failed' }));
    throw new Error(error.error || 'File upload failed');
  }

  return response.json();
}

export const edgeFunctions = {
  uploadFile,

  async analyzeMood(transcript: string) {
    return callEdgeFunction('mood-score', { transcript });
  },

  async analyzeFrame(image: string) {
    return callEdgeFunction('analyze-frame', { image });
  },

  async gradeSession(data: {
    transcript: string;
    videoFrames?: string[];
    jobTitle?: string;
    jobDescription?: string;
  }) {
    return callEdgeFunction('grade-session', data);
  },

  async createCustomInterview(data: {
    jobTitle: string;
    companyName: string;
    jobDescription?: string;
    interviewType?: string;
    difficultyLevel?: string;
    duration?: number;
    voiceGender?: string;
  }) {
    return callEdgeFunction('custom-interview', data);
  },

  async extractResumeExperience(resumePath: string) {
    return callEdgeFunction('extract-resume-experience', { resumePath });
  },
};
